import styled from "@emotion/styled";
import tw from "tailwind.macro";

export const SubTotalContainer = styled.div`
    ${tw` p-4 flex justify-between mb-0`};
`;

export const Amount = styled.div`
    ${tw`text-yellow-500 text-lg`};
`;
export const Text = styled.div`
    ${tw` text-lg text-yellow-500`};
`;
